import { passiveEvent } from '@resn/gozer-misc';
import { debounce } from 'underscore';

class ResizeServiceClass {
    all = [];

    size = {
        width: window.innerWidth,
        height: window.innerHeight,
    };

    constructor() {
        this.onResize = debounce(this.onResize, 200);
        this.onResize = this.onResize.bind(this);

        this.addListeners();
    }

    addListeners() {
        window.addEventListener('resize', this.onResize, passiveEvent);
    }
    removeListeners() {
        window.removeEventListener('resize', this.onResize);
    }

    add(handler, run = false) {
        this.all.push(handler);
        if (run) handler();
    }

    remove(handler) {
        this.all.splice(this.all.indexOf(handler) >>> 0, 1);
    }

    get windowWidth() {
        return this.size.width;
    }

    get windowHeight() {
        return this.size.height;
    }

    onResize() {
        this.size.width = window.innerWidth;
        this.size.height = window.innerHeight;

        this.all.map((handler) => handler());
    }
}

const ResizeService = new ResizeServiceClass();

export default ResizeService;
